import { DeviceHistorySearchDto } from "../models/DeviceHistory";
import axios from "axios";
import baseUrl from "./baseUrl";

export default class DeviceHistoryApi {
	static resourceUrl = baseUrl + "/device-history";

	static async getDeviceHistory(data: {
		accessToken: string;
		searchDto: DeviceHistorySearchDto;
	}) {
		const { searchDto, accessToken } = data;
		const { query, sort, offset, limit, timestampRange } = searchDto;

		const url = `${this.resourceUrl}/search?query=${encodeURIComponent(
			JSON.stringify(query)
		)}&sort=${encodeURIComponent(
			JSON.stringify(sort)
		)}&offset=${encodeURIComponent(offset)}&limit=${encodeURIComponent(
			limit
		)}&timestampRange=${encodeURIComponent(JSON.stringify(timestampRange))}`;

		// Send a POST request
		const response = await axios({
			method: "GET",
			url,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + accessToken,
			},
		});

		return response.data;
	}
}
